import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Linkify from 'react-linkify';
import Icon, { IconTypeNames } from "Components/Icon";
import { Routes } from 'Utils/Constants';
import useTransactionInitiated from "Utils/Hooks/useTransactionInitiated";
import useMode, { MODE } from "Utils/Hooks/useMode";
import Header from "Components/Header/Header";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import LoadVipAccount from "Components/LoadVipAccount";
import useSession from "Utils/Hooks/useSession";
import useView, { VIEW } from "Utils/Hooks/useView";
import { capitalizeFirstLetter, clickifyPhoneNumber } from "Utils/Utils";
import bankIcon from 'Assets/Icons/bank.svg';

import "./Response.scss";
import MitekInprogress from "Components/MitekInprogress";
import { PRODUCTTYPES } from "Utils/Constants";
import zerobalanceIcon from "Assets/Icons/zerobalance.svg";
import DeviceVerification from "Pages/DeviceVerification/DeviceVerification";

const Response = (props) => {
  const timerRef = useRef(null);
  const redirectTimerRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { session, invalidateSession } = useSession();
  const { transactionInitiated } = useTransactionInitiated();
  const mode = useMode();
  const view = useView();
  const [ deviceverified, setDeviceVerified ] = useState(null);
  const [ noMobileOnFile, setNoMobileError ] = useState(null);
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIPP' : 'VIPO';
  document.title = productType + " - " + capitalizeFirstLetter(location.pathname.replace('/', '').replace('\\', ''));

  const isCashier = view === VIEW.cashier;
  var cashierCss = '';
  if (isCashier) {
    Object.values(session.uiStyleFields).forEach((style) => { cashierCss += style });
  }

  useEffect(() => {
    if (isEnrollment && isSuccess) {
      timerRef.current = setTimeout(() => history.push(navigateTo), 6000);
    }
    if (redirectUrl && !session.toggles.showTransactionConfirmation && !isCashier) {
      if (
        redirectUrl.transactionSucceeded !== "undefined" &&
        redirectUrl.transactionSucceeded
      ) {
        redirectTimerRef.current = setTimeout(
          () => WcRedirectWithOutCTA(),
          5000
        );
      }
    }
    
    window.addEventListener("popstate", (e) => {
      if (location.pathname === "/logout") {
        history.go(1);
      }
    });
    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(redirectTimerRef.current);
      window.removeEventListener("popstate", (e) => {
        if (location.pathname === "/logout") {
          history.go(1);
        }
      });
    };
  }, []);

  const {
    loggedOut = false,
    isEnrollment = false,
    isSuccess = false,
    isError = true,
    isBack = false,
    showButton = true,
    title = "Error",
    message = "An unexpected error has been received and your request cannot be processed. Please contact CAMS at 1-800-500-1973 for support using code I99.",
    fromOperator = {},
    formData = {},
    iconProps = {},
    allowRetry = true,
    showLoginLink = false,
    showHeader = true,
    buttonText,
    onClickClose,
    navigateTo = (transactionInitiated || deviceverified) ? ((mode === MODE.withdraw) ? Routes.WITHDRAW : Routes.DEPOSIT) : Routes.DASHBOARD,
    customButtons,
    redirectUrl
  } = { ...props, ...location.state }

  const formattedMessage = clickifyPhoneNumber(message);

  const defaultIconTypeName = isEnrollment ? (isSuccess ? IconTypeNames.enrollsuccess : IconTypeNames.enrollfail) : (isError ? IconTypeNames.error : IconTypeNames.check);
  iconProps.typeName = iconProps.typeName ?? defaultIconTypeName;

  const customButtonsComponents = customButtons?.map((customButton, index) => {
    return <Row key={index}><Col md={{ span: 8, offset: 2 }}>
      {
        (isCashier) ? null :
          (redirectUrl && !session.showTransactionConfirmation) ?

            <p style={{ color: 'rgba(0, 86, 73, 1)', fontSize: '20px', fontFamily: 'Montserrat', fontWeight: '300' }}>{customButton.label} <label style={{ color: 'rgba(0, 86, 73, 1)', fontSize: '18px', fontFamily: 'Montserrat', fontWeight: '700' }}>{session.operatorName}</label></p>

            :

            <button
              type="button"
              className={customButton.zeroBal ? "link text-center click-cancel" : "submit-button click-return-to-opr"}
              onClick={() => { (customButton.returnToOperator) ? WcRedirect(customButton) : history.push({ pathname: customButton.route, state: { notRedirect: customButton.notRedirect } }); }}
            >
              {customButton.icon && <img className="bank-icon" src={bankIcon} alt="Bank Icon"></img>}
              {customButton.label}
            </button>
      }
    </Col></Row>;
  });

  function WcRedirect(customButton) {
    if (customButton.returnUrl) {
      var queryStringSeperator = customButton.returnUrl.includes("?") ? "&" : "?";
      window.location.replace(
        customButton.returnUrl +
        queryStringSeperator + "transactionId=" +
        customButton.transactionId +
        "&transactionType=" +
        customButton.transactionType
      );
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      }
      else if (window.parent !== null && window.parent.frames !== null && window.parent.frames.length > 0) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        }
      }
    }
    invalidateSession();
  }

  function WcRedirectWithOutCTA() {
    if (redirectUrl && redirectUrl.returnUrl) {
      var queryStringSeperator = redirectUrl.returnUrl.includes("?") ? "&" : "?";
      window.location.replace(
        redirectUrl.returnUrl +
        queryStringSeperator + "transactionId=" +
        redirectUrl.transactionId +
        "&transactionType=" +
        redirectUrl.transactionType
      );
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      } else if (window.parent !== null && window.parent.frames !== null && window.parent.frames.length > 0) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        }
      }
    }
    invalidateSession();
  }

  const onClick = () => {
    if (isError) {
      window.postMessage("close", "*");
    }
    if (onClickClose && window.opener !== null && !window.opener.closed) {
      window.close();
      return;
    }

    (isError && allowRetry) ? history.push({
      pathname: '/retry',
      state: {
        isError: true,
        fromOperator,
        formData,
        message
      }
    }) : history.push(navigateTo);
  };

  useEffect(() => {
    if (deviceverified === false) {
      redirectTimerRef.current = setTimeout(
        () => WcRedirect(customButtons[0]),
        20000
      );
    } else if (deviceverified) {
      history.push(navigateTo);
    } else if (noMobileOnFile) {
      history.push({ pathname: "/deviceverificationerror" });
    }
  }, [deviceverified, noMobileOnFile]);

  if (location.pathname === "/inprogress") {
    return (<>
      <MitekInprogress></MitekInprogress></>)
  }
  else if (!isEnrollment && location.pathname === "/deviceverification") {
    return <DeviceVerification verified={setDeviceVerified} noMobileError={setNoMobileError}/>
  }
  else if (location.pathname === "/zerobalance") {
    return (
      <>
        {showHeader && session && (
          <Header back={false} isEnrollment={isEnrollment && isSuccess} />
        )}
        <div className="response">
          <div className="response-header">{title}</div>
          <div className="response-message">Account Balance</div>
          <div className="response-message">
            <div>
              <div className="add-funding-source-zero-balance">
                <img src={zerobalanceIcon} alt='Add Funding Source Error' style={{ 'paddingTop': '5px', 'paddingBottom': '10px' }}></img>
                <p>{formattedMessage}</p>
              </div>
            </div>
          </div>
          {customButtonsComponents}
        </div>
      </>
    );
  }
  else if (loggedOut || location.pathname === "/expired" || isError || isBack) {
    return (
      <>
        {showHeader && session && (
          <Header back={false} isEnrollment={isEnrollment && isSuccess} />
        )}
        <div className="response">
          <Icon {...iconProps} />
          <div className="response-header">{title}</div>
          <div className="response-message">
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              {formattedMessage}
            </Linkify>
          </div>
          {!isSuccess && showButton && !customButtons && !isBack && (
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <button
                  type="button"
                  className="submit-button click-expired-or-error-ok"
                  onClick={onClick}
                >
                  {buttonText || (isError ? "OK" : "DONE")}
                </button>
              </Col>
            </Row>
          )}
          {customButtonsComponents}
          {showLoginLink && <a href="/">Log In</a>}
        </div>
      </>
    );
  }

  else {
    return (
      <LoadVipAccount isEnrollment={isEnrollment}>
          <style>{cashierCss}</style>
        {showHeader && session && !isCashier && (
          <Header back={false} isEnrollment={isEnrollment && isSuccess} />
        )}
          <div className="cashier-background">
        <div className="response">
          <Icon {...iconProps} />
          <div className="response-header">{title}</div>
          <div className="response-message">
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              {formattedMessage}
            </Linkify>
          </div>
          {!isSuccess && showButton && !customButtons && (
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <button
                  type="button"
                  className="submit-button click-unknown-error-ok"
                  onClick={onClick}
                >
                  {buttonText || (isError ? "OK" : "DONE")}
                </button>
              </Col>
            </Row>
          )}
          {customButtonsComponents}
          {showLoginLink && <a href="/">Log In</a>}
        </div>
        </div>
      </LoadVipAccount>
    );
  }
};

export default Response;